// src/utils/fieldAccessConfig.js
import { doc, getDoc } from "firebase/firestore";
import { db } from "../lib/firebase";

function normalizePin(value) {
  return String(value ?? "").trim();
}

export async function getFieldAccessPins() {
  const ref = doc(db, "appConfig", "general");
  const snap = await getDoc(ref);

  if (!snap.exists()) {
    return {
      responderPin: "",
      hqPin: "",
      dispatchPin: "",
      commandPin: "",
    };
  }

  const data = snap.data();
  const fieldAccess = data?.fieldAccess || {};

  return {
    responderPin: normalizePin(fieldAccess.responderPin),
    hqPin: normalizePin(fieldAccess.hqPin),
    dispatchPin: normalizePin(fieldAccess.dispatchPin),
    commandPin: normalizePin(fieldAccess.commandPin),
  };
}

export function pinsMatch(enteredPin, savedPin) {
  return normalizePin(enteredPin) === normalizePin(savedPin);
}